import SectionTitle from "@/components/base/SectionTitle";
import ExportPanel from "@/pages/admin/respaldo/components/ExportPanel";
import ImportPanel from "@/pages/admin/respaldo/components/ImportPanel";
import DataManagement from "@/pages/admin/respaldo/components/DataManagement";
import SelectiveDeletePanel from "@/pages/admin/respaldo/components/SelectiveDeletePanel";
import AccountingResetPanel from "@/pages/admin/respaldo/components/AccountingResetPanel";
import PdfCatalogPanel from "@/pages/admin/respaldo/components/PdfCatalogPanel";

const RespaldoPage = () => {
  return (
    <div className="pb-24">
      <SectionTitle
        text="Respaldo y Restauración"
        subtitle="Descarga un respaldo total en JSON y vuelve a cargarlo eligiendo qué categorías recuperar, sin sobrescribir lo que ya tienes."
      />

      <div className="glass-panel rounded-lg p-5 md:p-6 mb-5">
        <div className="flex flex-col lg:flex-row lg:items-center gap-4">
          <span className="w-12 h-12 rounded-lg bg-accent-500/20 text-accent-200 flex items-center justify-center shrink-0">
            <i className="ri-database-2-line text-2xl" />
          </span>
          <div className="flex-1">
            <h3 className="editable-title text-lg font-bold">Migración en 3 pasos</h3>
            <p className="text-xs md:text-sm text-foreground-600 mt-1">
              1) Descarga tu respaldo total como JSON. 2) Carga el PDF para actualizar precios del
              catálogo. 3) Restaura un respaldo cuando lo necesites, eligiendo por categoría y sin
              sobrescribir: solo se anexa lo que falta.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-4 mb-5">
        <PdfCatalogPanel />
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <ExportPanel />
        <ImportPanel />
      </div>

      <div className="mt-4 mb-5">
        <SelectiveDeletePanel />
      </div>

      <div className="mt-4 mb-5">
        <AccountingResetPanel />
      </div>

      <div className="mt-4">
        <DataManagement />
      </div>
    </div>
  );
};

export default RespaldoPage;